import React, { useState, useRef } from "react";
import { Icon, Image } from "semantic-ui-react";
import BCDragAndDrop from "./BCDragAndDrop";
import "../../styles/ui.scss";
import { FileType } from "../constants/GlobalConstants";

interface IBCUploadBoxProps {
  uploadTitle: string;
  uploadText: string;
  handleUploadFiles?: any;
  handleUploadFile?: any;
  isPreview?: boolean;
  uploadBoxClass?: string;
  verticalClass?: string;
}

const BCUploadBox = ({ ...props }: IBCUploadBoxProps) => {
  const [isFileDrag, setIsFileDrag] = useState(false as boolean);
  const [previewFileUrl, setPreviewFileUrl] = useState(undefined as string | undefined);
  const fileInputRef = useRef(null as any);

  const handleUpload = (files) => {
    if (props.handleUploadFiles) {
      props.handleUploadFiles(files);
    }
    else if (props.handleUploadFile) {
      props.handleUploadFile(files[0]);
    }
  };

  const handleDrop = (files) => {
    const uploadedFiles = [] as any[];
    if (files.length > 0) {
      for (const file of files) {
        if (file.type === FileType.JPEG || file.type === FileType.PNG) {
          uploadedFiles.push(file);
        }
      }

      handleUpload(files);
      if (props.isPreview && uploadedFiles.length) {
        setPreviewFileUrl(URL.createObjectURL(uploadedFiles[0]));
      }
    }
  };

  const handleFileChange = (e) => {
    handleUpload(e.target.files);
    if (props.isPreview) {
      setPreviewFileUrl(URL.createObjectURL(e.target.files[0]));
    }
  };

  return (
    <BCDragAndDrop 
      handleDropEvent={(files) => handleDrop(files)} 
      isDragging={isFileDrag}
      setIsDragging={setIsFileDrag} 
      onClick={() => fileInputRef.current.click()}
    >
      <input
        className="hidden-file-input"
        type="file"
        ref={fileInputRef}
        onChange={(e) => handleFileChange(e)}
      />
      <div className={`upload-border ${isFileDrag && "upload-drag"} ${props.uploadBoxClass ? props.uploadBoxClass : ""}`}>
        <div className={props.verticalClass ? props.verticalClass : "upload-container vertical-center"}>
          <React.Fragment>
            {previewFileUrl ? <Image 
              className="upload-stage-preview"
              src={previewFileUrl}
              /> : <Image className={"preview-upload upload-preview-default"}>
              <Icon name="upload" className="upload-logo-default-icon" />
            </Image>}
          </React.Fragment>
          <div className="upload-text upload-text-first"><b>{props.uploadTitle ? props.uploadTitle : "Drag your files here or browse"}</b></div>
          <div className="upload-text">{props.uploadText ? props.uploadText : "PDFs, JPEGs, and PNGs accepted"}</div>
        </div>
      </div>
    </BCDragAndDrop>
  );
};

export default BCUploadBox;
